<div class="contact-section">
  <h2>Get in Touch</h2>
  <p class="contact-intro">Have questions about Chareety? Our team is here to help. Send us a message and we'll respond within 24 hours.</p>
  <form (ngSubmit)="submitForm()" #contactForm="ngForm" class="contact-form">
    <div class="form-group">
      <label for="name">Full Name</label>
      <input type="text" id="name" name="name" [(ngModel)]="formData.name" required placeholder="Your Full Name">
    </div>
    <div class="form-group">
      <label for="email">Email Address</label>
      <input type="email" id="email" name="email" [(ngModel)]="formData.email" required email placeholder="your@organization.org">
    </div>
    <div class="form-group">
      <label for="message">Message</label>
      <textarea id="message" name="message" rows="5" [(ngModel)]="formData.message" required placeholder="Tell us about your nonprofit and how we can help..."></textarea>
    </div>
    <button mat-raised-button color="primary" type="submit" [disabled]="!contactForm.form.valid">Send Message</button>
  </form>
</div>